import React from 'react'

export function PieTwoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        d="M19.071 4.929l-.53.53.53-.53zM12 12h-.75c0 .414.336.75.75.75V12zm9.25 0A9.25 9.25 0 0112 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75h-1.5zM12 21.25A9.25 9.25 0 012.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75v-1.5zM2.75 12A9.25 9.25 0 0112 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12h1.5zM12 2.75A9.25 9.25 0 0121.25 12h1.5c0-5.937-4.813-10.75-10.75-10.75v1.5zm0 0a9.25 9.25 0 013.54.704l.574-1.386A10.75 10.75 0 0012 1.25v1.5zm3.54.704a9.25 9.25 0 013 2.005l1.061-1.06a10.75 10.75 0 00-3.487-2.33l-.574 1.385zm3 2.005a9.25 9.25 0 012.006 3.001l1.386-.574a10.75 10.75 0 00-2.33-3.487l-1.061 1.06zm2.006 3.001A9.251 9.251 0 0121.25 12h1.5c0-1.412-.278-2.81-.818-4.114l-1.386.574zM22 11.25H12v1.5h10v-1.5zm-9.25.75V2h-1.5v10h1.5z"
      />
    </svg>
  )
}
